export const SITE_MEDIA_BUCKET = "site-media";
export const MAX_BANNER_BYTES = 8 * 1024 * 1024;
export const BANNER_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;

export type SidebarBanner = {
  imagePath: string;
  imageUrl: string | null;
  targetUrl: string;
  altText: string | null;
};

export type AdminSidebarBanner = {
  imagePath: string | null;
  imageUrl: string | null;
  targetUrl: string | null;
  altText: string | null;
  isActive: boolean;
};

export function isExternalBannerUrl(url: string) {
  return /^https?:\/\//i.test(url);
}
